






















import { defineComponent } from '@vue/composition-api';
import { useI18n } from '@/plugins/i18n/i18n';

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(_, { emit }) {
    const bind = (dialog: boolean) => emit('input', dialog);
    return { bind, add: useI18n('common.create') };
  },
});
